import flowPagePlugin from './flowPagePlugin';
import openaiPlugin from './openaiPlugin';

export const allBuiltinPagePluginInfoList = [
  flowPagePlugin,
  openaiPlugin,
];
